import React from 'react'

function Osat() {
  return (
    <div>
     {/* <!-- Start Hero --> */}
     <section class="common-page-hero">
        <img src="assets/img/service/mw1.png" class="common-hero-bg ak-bg" alt="..." />
        <div class="common-hero-content">
            <div class="common-hero-info">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    <p class="ak-section-subtitle animation-title"  style={{color:'white'}}> Courses</p>
                    <h2 class="ak-section-title animation-title" style={{fontSize:'45px',color:'white'}}>
                    SEMANTIC Skills Junction: Bridging Talent and Technology
                    </h2>
                </div>
                <p class="back-btn" style={{color:'white'}}><a href="/">Home</a> / Course</p>
            </div>
            <a href="" class="phone-number" style={{color:'white'}}>(+91) 7619617023</a>
        </div>
    </section>
    {/* <!-- End Hero --> */}
    {/* <!-- Start Service --> */}
   
     {/* <div class="ak-height-75 ak-height-lg-50"></div> */}
    <section>
        <div class="container" style={{marginTop:'20px'}}>
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                <h3 class="ak-section-title animation-title" style={{fontSize:'40px'}}>
                Employment Ready OSAT, ATMP Professional Training Program

                </h3>
                <p class="ak-section-desp"   style={{textAlign:'justify'}}>
                We provide a comprehensive training program designed to prepare professionals for careers in Outsourced Semiconductor Assembly and Test (OSAT) and Advanced Technology Manufacturing Processes (ATMP). Our curriculum builds expertise from foundational concepts to advanced assembly and operations, with a strong focus on practical skills, industry standards, and quality excellence.

                </p>
            </div>
            <div class="ak-height-50 ak-height-lg-30"></div>
            {/* <!-- Start Images --> */}
            {/* <div class="content-image-container" style={{display: "flex"}}> */}
    {/* <div class="image-hov-one" style={{flex: "1"}}>
        <img class="img-fluid" src="assets/img/service/c1.png" alt="..." />
    </div>
    <div class="text-content" style={{flex: "1",marginLeft:'60px'}}>
        <p style={{margin: "0"}}>
            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
            The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
            content here', making it look like readable English. It is a long established fact that a reader will be distracted by the 
            readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less 
            normal distribution.
        </p>
    </div> */}
{/* </div> */}
            <div class="image-hov-one" >
                <img class="img-fluid" src="assets/img/service/m2.png" alt="..."  style={{marginRight:"20px"}}/>
                
            </div>
            {/* <div class="ak-height-50 ak-height-lg-30"></div> */}
            <p>
            
            </p>
            {/* <!-- End Images --> */}
        </div>
    </section>
    {/* <!-- End Service Details --> */}
  


    {/* <!-- Start Team --> */}
    {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
    <section>
        <div class="container">
            <div class="ak-section-heading-content">
                
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3 ak-w-60">
                    <p class="ak-section-subtitle animation-title" style={{marginTop:"20px",fontSize:'20px'}}>Program Structure</p>
                    {/* <h2 class="ak-section-title animation-title" style={{fontSize:'25px'}}>
                    Comprehensive training program to prepare you for a successful career in semiconductor fabrication
                    </h2> */}
                </div>
                
            </div>
            <h3 class="ak-section-title animation-title" style={{fontSize:'35px',textAlign:'center',marginTop:'10px'}}>
            Advanced Packaging Technologies

                </h3>
                <h2  style={{fontSize:'25px',marginTop:'20px'}}>
                Hands-on training program aimed at preparing you for a rewarding career in OSAT and the future of advanced packaging technologies.
                    </h2>
            {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
            <div class="ak-slider ak-team-slider" >
                <div class="swiper-wrapper" style={{marginTop:'20px'}}>
                    <div class="swiper-slide">
                        <a href="/manufacturing" class="team-card style-two h-100">
                            <div class="team-thamnel">
                                <img src="./assets/img/service/os1.jpeg" alt="..." />
                                <div class="img-overlay"></div>
                                {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                            </div>
                            <div class="team-body">
                                <div class="team-info">
                                    <h5 class="title">Basics & Devices</h5>
                                    <p class="short-title">
                                    <ul >
                                    <ul style={{textAlign:'justify'}}>
                <li>Gain a thorough understanding of the semiconductor industry and the wafer processing.</li>
                <li>Explore package types, evolution, and design concepts.</li>
                <li>Learn wafer-level packaging and supply chain dynamics.</li>
            </ul>
                </ul>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide">
                        <a href="/manufacturing" class="team-card style-two h-100">
                            <div class="team-thamnel">
                                <img src="./assets/img/service/mw4.png" alt="..." />
                                <div class="img-overlay"></div>
                                {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                            </div>
                            <div class="team-body">
                                <div class="team-info">
                                    <h5 class="title">Assembly Processes</h5>
                                    <p class="short-title">
                                    <ul class="space-y-2">
                                    <ul style={{textAlign:'justify'}}>
                <li>Master key processes like dicing, die attach, wire attach, and encapsulation.</li>
                <li>Understand the advanced packaging methods, including flip-chip and 3D approaches.</li>
                <li>Learn the role of technology evolution, testing, and equipment inspection.</li>
            </ul>
                </ul>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide">
                        <a href="/manufacturing" class="team-card style-two h-100">
                            <div class="team-thamnel">
                                <img src="./assets/img/service/mw8.png" alt="..." />
                                <div class="img-overlay"></div>
                                {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                            </div>
                            <div class="team-body">
                                <div class="team-info">
                                    <h5 class="title"> OSAT Operations</h5>
                                    <p class="short-title">
                                    <ul class="space-y-2">
                                    <ul style={{textAlign:'justify'}}> 
                <li>Develop expertise in cleanroom practices and environmental monitoring.</li>
                <li>Understand OSAT organization structures, capacity utilization, and KPIs.</li>
                <li>Emphasize safety and the 5S practices, environmental sustainability, and data integrity in daily operations.</li>
            </ul>
                </ul>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide">
                        <a href="/osat" class="team-card style-two h-100">
                            <div class="team-thamnel">
                                <img src="./assets/img/service/mw9.png" alt="..." />
                                <div class="img-overlay"></div>
                                {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                            </div>
                            <div class="team-body">
                                <div class="team-info">
                                    <h5 class="title">Quality Toolkit</h5>
                                    <p class="short-title">
                                    <ul class="space-y-2">
                                    <ul style={{textAlign:'justify'}}>
                <li>Equip yourself with essential quality tools, including FMEA, 8D problem solving, and SPC.</li>
                <li>Learn change management, excursion handling, and control plans.</li>
                <li>Focus on calibration, reliability testing, and the automotive mindset.</li>
            </ul>
                </ul>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="service-swiper-controller" style={{marginLeft:'1000px'}}>
                    <button class="service-next-btn slider-btn next">
              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
                    <button class="service-prev-btn slider-btn prev">
              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
                </div>
            </div>
        </div>
    </section>

     {/* <!-- Start Testmonial --> */}
     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
     <section>
        <div class="container">
            <div class="testmonial-top-content">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    {/* <p class="ak-section-subtitle animation-title">Feedback</p> */}
                    <h2 class="ak-section-title animation-title" style={{fontSize:"40px"}}>
                    Step into the Future of OSAT and Advanced Packaging
                    </h2>
                </div>
                {/* <div class="testmonial-top-desp">
                The semiconductor industry is at the forefront of technological innovation, driving advancements in key areas such as 5G, Artificial Intelligence (AI), Robotics, IoT, Automotive technology, and High-Performance Computing (HPC). Here's an overview of the market's tremendous growth potential:
                </div> */}
            </div>
            {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
            <div class="testmonial-content ak-slider ak-slider-testmonial">
                <div class="swiper-wrapper" style={{marginTop:'20px'}}>
                    <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/service/os.jpeg" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                India Semiconductor Mission: Empowering the Industry

                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h3 class="testmonial-title" style={{fontSize:'23px',lineHeight: '1.5'}}>
                                <strong>Program Highlights:</strong> <br/>
      <ul style={{fontSize:'19px',marginLeft:'20px'}}>
      
      <li>Full Prep to start work in OSAT, ATMP</li>
        <li>15+ courses structured into 4 modules</li>
        <li>Duration: 80+ hours / 3 -5 weeks full time</li>
        
      </ul>
      <strong>Additional Features:</strong><br/>
      <ul style={{fontSize:'19px',marginLeft:'20px'}}>
        <li>Includes industry relevant videos
</li>
        <li>Orientation visit to OSAT Cleanroom</li>
        <li> Delivery: Face to Face</li>
      </ul>

                                </h3>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                                {/* <div class="person-info">
                                    <div>
                                        <p class="name">Andrew Taylor</p>
                                        <p class="form">From USA</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
                        <path
                          d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
                          fill="#485B60"
                        />
                      </svg>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/bg/bg6.png" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                Growing Demand and Key Industry Players
                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h4 class="testmonial-title" style={{fontSize:'28px'}}>
                              <strong>Additional Features:</strong>
      <ul>
        <li>Orientation visit to a Fab Cleanroom</li>
        <li>Includes industry relevant videos</li>
        <li>Delivery Mode: Face-to-Face</li>
      </ul>
   
                                </h4>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                               
                            </div>
                        </div>
                    </div> */}
                </div>
                <div class="testmonial-controller">
                    {/* <div class="testmonial-swiper-controller">
                        <button class="testmonial-next-btn slider-btn next">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                        <button class="testmonial-prev-btn slider-btn prev">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                    </div> */}
                    {/* <div>
                        <p class="ak-black-color mb-0 ak-medium">350+ Over</p>
                        <p class="ak-font-16 mb-0">User Feedback</p>
                    </div> */}
                </div>
            </div>
        </div>
    </section>
    {/* <!-- End Testmonial --> */}


     {/* <!-- Start Feature --> */}
     {/* <div class="ak-height-100 ak-height-lg-50"></div> */}
     <h3 class="ak-section-title animation-title" style={{fontSize:'35px',textAlign:'center',marginTop:'10px'}}>
     Comprehensive Training Program for OSAT and ATMP: Your Path to Excellence in Semiconductor Packaging
                </h3>
                {/* <h2  style={{fontSize:'15px',marginTop:'20px' ,textAlign:'center'}}>
                This program equips candidates with advanced skills in DFT and analog circuit design, offering an industry-aligned curriculum, hands-on training, and certifications. Graduates are prepared for key roles like Wafer Fab Process Engineer, Quality Engineer, and more in the IC design and manufacturing industry
                    </h2> */}
    <section class="container">
        <div class="feature-content gap-2" style={{marginTop:'10px'}}>
            <div class="feature-card">
                <img class="feature-icon" src="./assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Prerequisites</h5>
                    <p style={{textAlign:'justify'}}>
                    This programme is tailored for individuals seeking advanced expertise in OSAT and ATMP processes. Candidates should possess a <strong>background in Engineering or Science</strong>, particularly in fields like <strong>background in Engineering or Science</strong> in fields such as 
                   

   
    
  </p>
  <ul>
    <li>Electronics</li>
    <li>Electrical</li>
    <li>Mechanical</li>
    <li>Chemical Engineering</li>
    <li>Physics, or Material Science</li>
   
  </ul>

                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Program Benefits</h5>
                    <p style={{textAlign:'justify'}}>Unlike traditional programs, this initiative bridges gaps in packaging and testing, focusing on critical OSAT and ATMP areas.</p>
  <ul>
    {/* <li>Industry-aligned curriculum</li> */}
    <li>Hands-on practical exposure to advanced packaging processes</li>
    {/* <li>In-depth knowledge of testing methodologies</li> */}
    <li>Expertise in quality management and defect analysis</li>
    <li>Skill development for career-ready professionals</li>
    <li>Certifications aligned with industry standards</li>
  </ul>
                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Career Opportunities
                    </h5>
                    <p style={{textAlign:'justify'}}>
    This programme equips participants with specialized skills in OSAT and ATMP, 
    preparing them for dynamic roles in the semiconductor industry, such as:
  </p>
  <ul>
  <li>Test Engineer</li>
    <li>Quality Assurance Engineer</li>
    <li>Yield Improvement Engineer</li>
    <li>Failure Analysis Specialist</li>
    <li>Reliability Engineer</li>
    <li>Failure Analysis Engineer</li>
  </ul>
                </div>
            </div>
        </div>
    </section>
    <span class="ak-scrollup">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
          fill="currentColor"
        />
      </svg>
    </span>
    </div>
  )
}

export default Osat
